module.exports = __webpack_public_path__ + "static/2-5d6d76247619e705ece4be89bd0cafbe.png";